import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=b64b47f4"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b64b47f4')) {
      api.createRecord('b64b47f4', component.options)
    } else {
      api.reload('b64b47f4', component.options)
    }
    module.hot.accept("./Tax.vue?vue&type=template&id=b64b47f4", function () {
      api.rerender('b64b47f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/deliveryNotes/Tax.vue"
export default component.exports